// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"video_videoContainer__onKLc","fullHeight":"video_fullHeight__nB8bT","play":"video_play__6RsCn","playing":"video_playing__VtYlU"};